// var ELEARR = []
// var CONTAINERARR = []
export default {
	zhongxintongji() {
		let script = document.createElement('script')
		script.type = 'text/javascript'
		script.src = '//tagcdn.marketin.cn/tm-citic-000662.js'
		document.getElementsByTagName('head')[0].appendChild(script)
	},
	device() {
		let sUserAgent = navigator.userAgent.toLowerCase();
		let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
		let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
		let bIsMidp = sUserAgent.match(/midp/i) == "midp";
		let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
		let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
		let bIsAndroid = sUserAgent.match(/android/i) == "android";
		let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
		let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
		if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
			if (bIsIphoneOs) {
				return 'ios'
			} else if (bIsAndroid) {
				return 'android'
			} else {
				return 'phone'
			}
		} else {
			return 'pc'
		}
	},
	isWeiXin() {
		let ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true; // 是微信端
		} else {
			return false;
		}
	},
	isFeishu() {
		let ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/feishu/i) == 'feishu') {
			return true; // 是微信端
		} else {
			return false;
		}
	},
	getUrl() {
		let url = window.location.toString()
		if (url.indexOf("?") != -1) {
			url = url.split("?")[0]
		}
		return url
	},
	getParam(paraName, def = null) {
		let url = window.location.toString()
		let arrObj = url.split("?")
		if (arrObj.length > 1) {
			let arrPara = arrObj[1].split("&")
			let arr;
			for (let i = 0; i < arrPara.length; i++) {
				arr = arrPara[i].split("=")
				if (arr != null && arr[0] == paraName) {
					return arr[1]
				}
			}
			return def
		} else {
			return def
		}
	},
	afterInput() {
		return new Promise((resolve) => {
			// alert(1)
			// resolve()
			setTimeout(() => {
				const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
				window.scrollTo(0, Math.max(scrollHeight - 1, 0));
				resolve()
			}, 50);
		})

	},

	dataURLtoBlob: function(dataurl) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], {
			type: mime
		});
	},
	//将blob转换为file
	blobToFile: function(theBlob, fileName) {
		theBlob.lastModifiedDate = new Date();
		theBlob.name = fileName;
		return theBlob;
	},

	compress(file, success, error) {
		if (file.size < Math.pow(1024, 2)) {
			return success(file)
		}
		const name = file.name
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = function(e) {
			window.console.log(e)
			const src = e.target.result
			const img = new Image()
			img.src = src
			img.onload = function() {
				const w = img.width
				const h = img.height
				const quality = 0.8
				// 生成canvas
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				// 创建属性节点
				const anw = document.createAttribute("width");
				anw.nodeValue = w
				const anh = document.createAttribute("height");
				anh.nodeValue = h
				canvas.setAttributeNode(anw)
				canvas.setAttributeNode(anh)

				// 铺底色 PNG转JPEG时透明区域会变黑色
				ctx.fillStyle = "#fff"
				ctx.fillRect(0, 0, w, h)

				ctx.drawImage(img, 0, 0, w, h)
				// quality值越小，所绘制出的图像越模糊
				const base64 = canvas.toDataURL('image/jpeg', quality) // 图片格式jpeg或webp可以选0-1质量区间

				// 返回base64转blob的值
				//window.console.log(`原图${(src.length/1024).toFixed(2)}kb`, `新图${(base64.length/1024).toFixed(2)}kb`)
				// 去掉url的头，并转换为byte
				const bytes = window.atob(base64.split(',')[1])
				// 处理异常,将ascii码小于0的转换为大于0
				const ab = new ArrayBuffer(bytes.length)
				const ia = new Uint8Array(ab)
				for (let i = 0; i < bytes.length; i++) {
					ia[i] = bytes.charCodeAt(i);
				}
				file = new Blob([ab], {
					type: 'image/jpeg'
				});
				file.name = name
				success(file)
			}
			img.onerror = function(e) {
				error(e);
			}
		}
		reader.onerror = function(e) {
			error(e);
		}
	},
	timeFormData(time) {
		let date = time.substr(0, 10); //年月日
		let hours = time.substring(11, 13);
		let minutes = time.substring(14, 16);
		let seconds = time.substring(17, 19);
		let timeFlag = date + ' ' + hours + ':' + minutes + ':' + seconds;
		timeFlag = timeFlag.replace(/-/g, "/");
		timeFlag = new Date(timeFlag);
		timeFlag = new Date(timeFlag.getTime() + 8 * 3600 * 1000);
		timeFlag = timeFlag.getFullYear() + '-' + ((timeFlag.getMonth() + 1) < 10 ? "0" + (timeFlag.getMonth() + 1) : (
				timeFlag.getMonth() + 1)) + '-' + (timeFlag.getDate() < 10 ? "0" + timeFlag.getDate() : timeFlag
				.getDate()) + ' ' +
			timeFlag.getHours() + ':' + timeFlag.getMinutes() + ':' + (timeFlag.getSeconds() < 10 ? "0" + timeFlag
				.getSeconds() :
				timeFlag.getSeconds());
		return timeFlag;
	},
	timestampToDate(timestamp) {
		let date = new Date(timestamp * 1000);
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = date.getDate() + ' ';
		let h = date.getHours() + ':';
		let m = date.getMinutes() + ':';
		let s = date.getSeconds();
		return Y + M + D + h + m + s;
	},
	setLocalStorage(key, value) {
		localStorage.setItem(key, value)
	},
	getLocalStorage(key) {
		return localStorage.getItem(key)
	},
	removeLocalStorage(key) {
		return localStorage.removeItem(key)
	},

	getLoction() {
		return new Promise((resolve) => {
			let myCity = new window.BMap.LocalCity()
			myCity.get(function(result) {
				let lng = result.center.lng
				let lat = result.center.lat
				let point = new window.BMap.Point(lng, lat)
				let gc = new window.BMap.Geocoder()
				gc.getLocation(point, (res) => {
					resolve(res)
				})
			})
		})
	},
	checkPhone(phone) {
		if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
			return false;
		} else {
			return true
		}
	},

	PrefixZero(num, n) {
		return (Array(n).join(0) + num).slice(-n);
	},
	formatDate(date, format) {
		const map = {
			mm: this.PrefixZero(date.getMonth() + 1,2),
			dd: this.PrefixZero(date.getDate(),2),
			yy: date.getFullYear().toString().slice(-2),
			yyyy: date.getFullYear()
		}
		return format.replace(/mm|dd|yyyy/gi, matched => map[matched])
	},
	bMapToQQMap(lng, lat) {
		if (lng == null || lng == '' || lat == null || lat == '') {
			return {
				lng: lng,
				lat: lat
			}
		} else {
			let x_pi = 3.14159265358979324;
			let x = parseFloat(lng) - 0.0065;
			let y = parseFloat(lat) - 0.006;
			let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
			let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
			let _lng = (z * Math.cos(theta)).toFixed(7);
			let _lat = (z * Math.sin(theta)).toFixed(7);
			return {
				lng: _lng,
				lat: _lat
			}
		}
	},
	qqMapToBMap(lng, lat) {
		if (lng == null || lng == '' || lat == null || lat == '') {
			return {
				lng: lng,
				lat: lat
			}
		} else {
			let x_pi = 3.14159265358979324;
			let x = parseFloat(lng);
			let y = parseFloat(lat);
			let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
			let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
			let _lng = (z * Math.cos(theta) + 0.0065).toFixed(5);
			let _lat = (z * Math.sin(theta) + 0.006).toFixed(5);
			return {
				lng: _lng,
				lat: _lat
			}
		}
	},
	cloneArr(arr) {
		return arr.slice(0)
	},
	getRandom(min, max) {
		return Math.floor(Math.random() * (max - min + 1) + min)
	},
	shuffle(arr, flag = false) {
		// console.log('arr',arr)
		let newArr = []
		flag ? (newArr = arr) : (newArr = this.cloneArr(arr))

		for (let i = 0; i < newArr.length; i++) {
			let j = this.getRandom(0, i)
			let temp = newArr[i]
			newArr[i] = newArr[j]
			newArr[j] = temp
		}
		// console.log('arr',arr,newArr)

		return newArr
	},
	//===========================tweenmax=============================

	fadeIn(ele, time, direction = '', repeat = 0, yoyo = true) {
		let animate
		switch (direction) {
			case 'up':
				ele.y += 50
				ele.alpha = 0
				animate = new window.TweenMax(ele, time, {
					y: ele.y - 50,
					alpha: 1,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			case 'down':
				ele.y -= 50
				ele.alpha = 0
				animate = new window.TweenMax(ele, time, {
					y: ele.y + 50,
					alpha: 1,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			case 'left':
				ele.x -= 50
				ele.alpha = 0
				animate = new window.TweenMax(ele, time, {
					x: ele.x + 50,
					alpha: 1,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			case 'right':
				ele.x += 50
				ele.alpha = 0
				animate = new window.TweenMax(ele, time, {
					x: ele.x - 50,
					alpha: 1,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			default:
				ele.alpha = 0
				animate = new window.TweenMax(ele, time, {
					alpha: 1,
					yoyo: yoyo,
					repeat: repeat,
				})
		}
		return animate
	},
	fadeOut(ele, time, direction = '', repeat = 0, yoyo = true) {
		let animate
		switch (direction) {
			case 'up':
				animate = new window.TweenMax(ele, time, {
					y: ele.y - 100,
					alpha: 0,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			case 'down':
				animate = new window.TweenMax(ele, time, {
					y: ele.y + 100,
					alpha: 0,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			case 'left':
				animate = new window.TweenMax(ele, time, {
					x: ele.x - 100,
					alpha: 0,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			case 'right':
				animate = new window.TweenMax(ele, time, {
					x: ele.x + 100,
					alpha: 0,
					yoyo: yoyo,
					repeat: repeat,
				})
				break;
			default:
				animate = new window.TweenMax(ele, time, {
					alpha: 0,
					yoyo: yoyo,
					repeat: repeat,
				})
		}
		return animate
	},
	rotate(ele, time, rotation, repeat = 0, yoyo = true) {
		//this.rejuctCenter(ele)
		return new window.TweenMax(ele, time, {
			rotation: rotation,
			yoyo: yoyo,
			repeat: repeat,
			ease: window.Power0.easeIn
		})
	},
	pulse(ele, time, scale, repeat = 0, yoyo = true) {
		this.rejuctCenter(ele)
		return new window.TweenMax(ele, time, {
			scaleX: scale,
			scaleY: scale,
			yoyo: yoyo,
			repeat: repeat,
			ease: window.Power0.easeIn
		})
	},
	zoomIn(ele, time, repeat = 0, yoyo = true) {
		this.rejuctCenter(ele)
		ele.scaleX = 0
		ele.scaleY = 0
		return new window.TweenMax(ele, time, {
			scaleX: 1,
			scaleY: 1,
			yoyo: yoyo,
			repeat: repeat,
			ease: window.Power0.easeIn
		})
	},
	flash(ele, time, alpha = 0, repeat = 0, yoyo = true) {
		return new window.TweenMax(ele, time, {
			alpha: alpha,
			yoyo: yoyo,
			repeat: repeat,
			ease: window.Power0.easeIn
		})
	},
	rejuctCenter(obj, center = true, point = {}) {
		if (center) {
			obj.regX = obj.w / 2
			obj.regY = obj.h / 2
			obj.x += obj.w / 2
			obj.y += obj.h / 2
		} else {
			obj.regX = point.x
			obj.regY = point.y
			obj.x += point.x
			obj.y += point.y
		}

	},

	// createSprite(arr) {
	// 	var frames = []
	// 	for (let x in arr) {
	// 		let tempArr = []
	// 		tempArr.push(arr[x].x)
	// 		tempArr.push(arr[x].y)
	// 		tempArr.push(arr[x].w)
	// 		tempArr.push(arr[x].h)
	// 		tempArr.push(0)
	// 		tempArr.push(-arr[x].offX)
	// 		tempArr.push(-arr[x].offY)
	// 		frames.push(tempArr)
	// 	}
	// 	return frames
	// },



	// createMask(obj) {
	// 	let shape = new window.createjs.Shape();
	// 	shape.graphics.beginFill("#000000").drawRect(obj.x1, obj.y1, obj.x2, obj.y2)
	// 	return shape
	// },



	// createElement(item, stage) {
	// 	let ele
	// 	let ELEARR = []
	// 	let CONTAINERARR = []
	// 	window.console.log(item, stage)
	// 	switch (item.type) {
	// 		case 'img':
	// 			let src = '../img/' + item.imgname + '.' + item.imgtype
	// 			ele = new window.createjs.Bitmap(require(src));
	// 			ele.name = item.name
	// 			ele.x = item.x
	// 			ele.y = item.y
	// 			ele.w = item.w
	// 			ele.h = item.h
	// 			stage.addChild(ele)
	// 			ELEARR[item.name] = ele
	// 			break;
	// 		case 'container':
	// 			var container = new window.createjs.Container()
	// 			container.x = item.x
	// 			container.y = item.y
	// 			container.w = item.w
	// 			container.h = item.h
	// 			stage.addChild(container)
	// 			item.children.forEach(function(child) {
	// 				let src = '../img/' + item.imgname + '.' + item.imgtype
	// 				var _child = new window.createjs.Bitmap(require(src));
	// 				_child.name = child.name
	// 				_child.x = child.x
	// 				_child.y = child.y
	// 				_child.w = child.w
	// 				_child.h = child.h
	// 				_child.container = container
	// 				container.addChild(_child)
	// 				ELEARR[child.name] = _child
	// 				CONTAINERARR[item.name] = container
	// 			})
	// 			break;
	// 		case 'sprite':
	// 			var frames = this.createSprite(item.sprites)
	// 			var data = {
	// 				images: ["./../img/" + item.imgname + ".png"],
	// 				frames: frames,
	// 				animations: {
	// 					run: {
	// 						frames: [0],
	// 						speed: 0.1
	// 					},
	// 				}
	// 			}
	// 			var spriteSheet = new window.createjs.SpriteSheet(data)
	// 			ele = new window.createjs.Sprite(spriteSheet, "run")
	// 			ele.x = item.x
	// 			ele.y = item.y
	// 			ele.w = item.w
	// 			ele.h = item.h
	// 			ele.gotoAndStop(0)
	// 			stage.addChild(ele)
	// 			ELEARR[item.name] = ele
	// 			break;
	// 	}
	// 	stage.ELEARR = ELEARR
	// 	stage.CONTAINERARR = CONTAINERARR
	// },

}
